import {changeEvent, clickEvent, customEvent, dispatchCustomEvent, keyupEvent} from "../../../webpack/modules/events";
import {calculate} from "../../../webpack/modules-optimized/wallpaper-calculator";
import {ga4TrackSimpleEvent} from "../../../webpack/modules/analytics";
import {slideDown, slideUp} from "../../../webpack/modules-optimized/element-visibility";

clickEvent('.wallpaper-calculator .btn-calculate', true, function(element) {
    let calculator = element.closest('.wallpaper-calculator');
    let errorRolls = calculator.querySelector('.error.wallpaper-calculator-error-rolls');
    let errorSizes = calculator.querySelector('.error.wallpaper-calculator-error-sizes');
    let wallWidth = calculator.querySelector('.wallpaper-calculator-width');
    let wallHeight = calculator.querySelector('.wallpaper-calculator-height');
    let rollSize = calculator.querySelector('input.wallpaper-calculator-roll-size:checked');
    let tool = calculator.querySelector('.wallpaper-calculator-tool');
    let result = calculator.querySelector('.wallpaper-calculator-result');
    let rollQuantity = calculator.querySelector('.roll-quantity');
    let glueQuantity = calculator.querySelector('.glue-complement-quantity');

    if (!rollSize) {
        slideDown(errorRolls);
        ga4TrackSimpleEvent(
            {
                event: 'calculator',
                method: 'error_size',
                product_type: 'wallpaper'
            }
        );
        return;
    }

    if (wallWidth.value === '' || wallHeight.value === '') {
        slideDown(errorSizes);
        return;
    }

    let unit = rollSize.dataset.unit;
    let conversion = rollSize.dataset.conversion;
    let productWidth = rollSize.dataset.width;
    let productHeight = rollSize.dataset.height;
    let calculatorResults = calculate(wallWidth.value, wallHeight.value, productWidth, productHeight, unit, conversion);

    rollQuantity.innerHTML = calculatorResults.rolls;
    glueQuantity.innerHTML = calculatorResults.glue;
    tool.classList.add('d-none');
    result.classList.remove('d-none');
    ga4TrackSimpleEvent(
        {
            event: 'calculator',
            method: 'calculate',
            product_type: 'wallpaper'
        }
    );
    dispatchCustomEvent(
        'wallpaperCalculatorResult',
        {
            'width': productWidth,
            'height': productHeight,
            'previewText': rollSize.dataset.previewText,
            'rolls': calculatorResults.rolls,
            'glue': calculatorResults.glue
        }
    );
    calculator.querySelectorAll('input[type="number"]').forEach((input) => input.value = '');
    calculator.querySelectorAll('input[name="wallpaper-calculator-roll-size"]').forEach((input) => input.checked = false);
});

changeEvent('.wallpaper-calculator .wallpaper-calculator-roll-size', true, function(element) {
    let calculator = element.closest('.wallpaper-calculator');
    let errorRolls = calculator.querySelector('.error.wallpaper-calculator-error-rolls');

    slideUp(errorRolls);
    ga4TrackSimpleEvent(
        {
            event: 'calculator',
            method: 'select_size',
            size: element.dataset.width + 'x' + element.dataset.height,
            product_type: 'wallpaper'
        }
    );
});

keyupEvent('.wallpaper-calculator .wallpaper-calculator-width, .wallpaper-calculator .wallpaper-calculator-height', true, function(element) {
    let calculator = element.closest('.wallpaper-calculator');
    let wallWidth = calculator.querySelector('.wallpaper-calculator-width');
    let wallHeight = calculator.querySelector('.wallpaper-calculator-height');
    let errorSizes = calculator.querySelector('.error.wallpaper-calculator-error-sizes');

    if (wallWidth.value !== '' && wallHeight.value !== '') slideUp(errorSizes);
});

clickEvent('.wallpaper-calculator .btn-back', true, function(element) {
    let calculator = element.closest('.wallpaper-calculator');
    let tool = calculator.querySelector('.wallpaper-calculator-tool');
    let result = calculator.querySelector('.wallpaper-calculator-result');

    tool.classList.remove('d-none');
    result.classList.add('d-none');
    ga4TrackSimpleEvent(
        {
            event: 'calculator',
            method: 'recalculate',
            product_type: 'wallpaper'
        }
    );
    dispatchCustomEvent('wallpaperCalculatorReset');
});

clickEvent('.wallpaper-calculator .btn-add-to-cart', true, function(element){
    ga4TrackSimpleEvent(
        {
            event: 'calculator',
            method: 'add_to_cart',
            product_type: 'wallpaper'
        }
    );
});

customEvent('shown.bs.collapse', '.wallpaper-calculator', false, function() {
    ga4TrackSimpleEvent(
        {
            event: 'calculator',
            method: 'open',
            product_type: 'wallpaper'
        }
    );
});
